import { render, staticRenderFns } from "./CategoryAddEditModal.vue?vue&type=template&id=215319a4"
import script from "./CategoryAddEditModal.vue?vue&type=script&lang=js"
export * from "./CategoryAddEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports